module.exports = __webpack_public_path__ + "img/datepage2.494cd0da.png";